export const REGISTER_GOOGLE_RECAPTCHA = 'registerRecaptcha'
export const BOOT_CAPTCHA_SERVICE = 'bootCaptchaService'
export const SET_CAPTCHA_SERVICE = 'setCaptchaService'
export const REFRESH_CAPTCHA = 'refreshCaptcha'
export const GET_GOOGLE_RECAPTCHA_TOKEN = 'getGoogleRecaptchaToken'
export const REMOVE_GOOGLE_RECAPTCHA_TOKEN = 'removeGoogleRecaptchaToken'
export const SET_GOOGLE_RECAPTCHA_TOKEN = 'setGoogleRecaptchaToken'
export const GET_SIMPLE_CAPTCHA = 'getSimpleCaptcha'
export const SET_SIMPLE_CAPTCHA = 'setSimpleCaptcha'
export const RESET_CAPTCHA_CONFIG = 'resetCaptchaConfig'